import React, { useRef, useEffect, useState } from "react";
import PropTypes from 'prop-types';

import {Box, Collapse, Typography} from "@mui/material";
import { makeStyles } from "tss-react/mui";

import MaskSelectorToolStyles from "../MaskSelectorToolStyles";

import BackNextNavigation from "../BackNextNavigation";
import new_scan_demo from "./new_scan_demo.gif";
import {useTranslation} from "react-i18next";

import {nextGenExpandHeightTransition} from "../AnimationConfig";
import SoundPlayer from "./SoundPlayer";

const expandingBGColour = "#001727";

const ScanPrepPage = ( { handleNext,
                           handlePrevious,
                           setLogoOverride,
                           setExpandedOverride,
                           setHeaderBgColor
                       } ) => {
    const { t } = useTranslation("pages.MaskSelectorTool.ScanPrepPage");

    const scanText = t("scanText");
    const scanInstructions = t("scanInstructions");

    const {classes} = MaskSelectorToolStyles();

    const [expanded, setExpanded] = useState(false);
    const [isTransitionComplete, setIsTransitionComplete] = useState(false);
    const [isTransitionRunning, setIsTransitionRunning] = useState(false);
    const [audioKey, setAudioKey] = useState(undefined);

    const handleTransitionEnd = () => {
        setIsTransitionRunning(false);
        setIsTransitionComplete(true);
    }

    const handleNextFunction = () => {
        setExpanded(!expanded);
        setLogoOverride(true);
        setExpandedOverride(true);
        setIsTransitionRunning(true);
        setHeaderBgColor(expandingBGColour)
    }

    const headingRef = useRef(null);

    const ScanInstructionsStyles = makeStyles()(() => ({
        header: {
            fontSize: '16px',
            fontWeight: 400
        },
        detail: {
            fontSize: 17,
            color: '#424243'
        },
        scanInstructions: {
            color: '#FFFFFF',
            textAlign: 'center',
            width: '335px',
            height: '60px',
            paddingTop: 2
        }
    }));

    const ScanPrepPageStyles = makeStyles()(() => ({
        prepScanButtonFooter: {
            "@media only screen and (min-width: 640px)": {
                width: '600px',
                alignItems: 'center'
            }
        }
    }));

    const {classes: scanPrepPageClasses} = ScanPrepPageStyles();
    const {classes: scanInstructionsClasses} = ScanInstructionsStyles();

    useEffect(() => {
        if (isTransitionComplete) {
            handleNext();
        }
    }, [isTransitionComplete, expanded, handleNext])


    useEffect(() => {
        if(headingRef?.current) {
            headingRef.current.focus();
        }
    });

    useEffect(() => {
        if (!isTransitionRunning) {
            setAudioKey("scanComposite");
        }
    }, [isTransitionRunning]);

    return (
    <>
        <Box className={classes.contentOuterFlexBox}
             sx={{position: 'absolute', left: '0%', alignItems: 'center', width: '100svw'}}>
            <Box
                sx={{height: '451px', width: '100%'}}
                 className={ `${classes.instructionMainBox} ${classes.contentInnerOverFlowBox}` }>
                {!isTransitionRunning && (
                    <SoundPlayer soundId={audioKey} />
                )}
                <Box sx={{height: '451px', width: '100svw'}}>
                    <Box
                        sx={{backgroundColor: "#001727", height: '395px', width: '100svw', position: 'relative',
                            left: "calc(50% - 50svw)"
                        }}
                        className={ `${classes.centeredBox}` }
                    >
                        <Box className={`${classes.centeredBox}`} sx={{flexDirection: 'column', alignItems: 'center'}}>
                            <img alt="" width={395} height={309} src={new_scan_demo} data-testid="new_scan_demo_gif"/>
                            <Typography className={scanInstructionsClasses.scanInstructions}>
                                {scanInstructions}
                            </Typography>
                        </Box>
                    </Box>
                    <Box pt="16px" pb="24px" className={classes.centeredBox}>
                        <Box width='80%'>
                            <Typography className={`${scanInstructionsClasses.header} ${classes.noOutline} 
                                ${classes.subHeadingTyp} ${classes.centeredText}`} tabIndex="0" ref={headingRef}>
                                {scanText}
                            </Typography>
                        </Box>
                    </Box>
                </Box>

                {/* Need to add padding so that the text can scroll past the transparent bit */}
                <Box mt = {'40px'}></Box>
            </Box>
            <Box className={scanPrepPageClasses.prepScanButtonFooter}>
                <BackNextNavigation
                    handleNext={handleNextFunction}
                    handlePrevious={handlePrevious}
                    nextLabel="Start scan"
                    nextDisabled={isTransitionRunning}
                    containerClassName={scanInstructionsClasses.questionButtons}
                />
            </Box>
        </Box>
        <Collapse in={expanded}>
            <Box
                sx={{
                    backgroundColor: expandingBGColour,
                    height: expanded ? '100%' : '395px',
                    transition: nextGenExpandHeightTransition,
                    width: '100svw',
                    position: expanded ? 'absolute' : 'relative',
                    left: "calc(50% - 50svw)"
                }}
                onTransitionEnd={handleTransitionEnd}
                className={ `${classes.centeredBox}` }
            >
                <Box sx={{width: '217px', height: '249px', borderRadius: '50%', border: '1px solid white'}}></Box>
            </Box>
        </Collapse>
    </>
    )
}
ScanPrepPage.propTypes = {
    handleNext: PropTypes.func.isRequired,
    handlePrevious: PropTypes.func.isRequired,
    setLogoOverride: PropTypes.func.isRequired,
    setExpandedOverride: PropTypes.func.isRequired,
    setHeaderBgColor: PropTypes.func.isRequired,
}

export default ScanPrepPage;
